export default "<p>mat-snack-bar works!</p>\n"